import React, { Component } from 'react'
import { recruiterKycDetails } from '../../action/profile';
import Shimmer from '../../old_Components/Common/Shimmer';
import AsideRightMenu from '../../old_Components/Dashboard/AsideRightMenu';
import KycForm from '../../old_Components/Kyc/KycForm'

export default class update extends Component {
    constructor(props) {
        super(props);
        this.state = {
            details: undefined
        }
    }

    componentDidMount() {
        recruiterKycDetails().then((res) => {
            if (res.status) {
                this.setState({ details: res.result })

            }
        })
    }
    render() {

        return (
            <React.Fragment>

                {this.state.details === undefined && <section className='pricing-area padding-top-100px padding-bottom-80px'>
                    <div className="container">
                        <div className='row'>
                            <div className='col-md-3 mt-3'>
                                <AsideRightMenu />
                            </div>
                            <div className='col-md-9'>
                                <Shimmer />
                            </div>
                        </div>
                    </div>

                </section>
                }
                {this.state.details && <KycForm
                    details={this.state.details} />}
            </React.Fragment>
        )
    }
}
